import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=4343866b"
import script from "./blank.vue?vue&type=script&lang=js"
export * from "./blank.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./blank.vue?vue&type=style&index=0&id=4343866b&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "33272886"
  
)

export default component.exports